export const API_APPROVAL_ROUTES = Object.freeze({
  PENDING_APPROVALS: '/submissions/approvals/pending',
  STAMP_APPROVAL: '/submissions/:submissionId/approval/stamp',
  REJECT_APPROVAL: '/submissions/:submissionId/approval/reject',
  EXECUTE_PAYMENT: '/submissions/:submissionId/approval/execute',
  // Manual creator payout approvals — separate queue, separate endpoints
  PENDING_MANUAL_PAYOUT_APPROVALS: '/payout/approvals/pending',
  STAMP_MANUAL_PAYOUT_APPROVAL: '/payout/:approvalId/approval/stamp',
  REJECT_MANUAL_PAYOUT_APPROVAL: '/payout/:approvalId/approval/reject',
  EXECUTE_MANUAL_PAYOUT_APPROVAL: '/payout/:approvalId/approval/execute',
});
